import { render, staticRenderFns } from "./HacizTalepForm.vue?vue&type=template&id=412843a0&scoped=true"
import script from "./HacizTalepForm.vue?vue&type=script&lang=ts"
export * from "./HacizTalepForm.vue?vue&type=script&lang=ts"
import style0 from "./HacizTalepForm.vue?vue&type=style&index=0&id=412843a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412843a0",
  null
  
)

export default component.exports